<template><ArticlePage page="blog-vs-gb" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/blog-vs-gb.js';
export default { name: 'BlogVsGb', components: { ArticlePage }, data: () => ({ content }) };
</script>
